import { render, staticRenderFns } from "./ContactUsReferral.vue?vue&type=template&id=9280beea&scoped=true&"
import script from "./ContactUsReferral.vue?vue&type=script&lang=js&"
export * from "./ContactUsReferral.vue?vue&type=script&lang=js&"
import style0 from "./ContactUsReferral.vue?vue&type=style&index=0&id=9280beea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9280beea",
  null
  
)

export default component.exports